import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';

export default function CallWaiterFAB({ tableNumber }) {
    const [state, setState] = useState('idle'); // idle | calling | done

    const handleCall = () => {
        if (state !== 'idle') return;
        setState('calling');
        // Simulate a short delay then show success
        setTimeout(() => {
            setState('done');
            // Reset back to idle after 4 seconds
            setTimeout(() => setState('idle'), 4000);
        }, 800);
    };

    return (
        <div className="fixed bottom-24 right-4 z-[140] animate-bounce-in">
            <AnimatePresence mode="wait">
                {state === 'done' ? (
                    <motion.div
                        key="done"
                        initial={{ scale: 0.8, opacity: 0 }}
                        animate={{ scale: 1, opacity: 1 }}
                        exit={{ scale: 0.8, opacity: 0 }}
                        className="bg-green-500 text-white rounded-2xl px-4 py-3 shadow-xl flex items-center gap-2 text-sm font-black whitespace-nowrap"
                    >
                        <span className="text-lg">✅</span>
                        Waiter on the way!
                    </motion.div>
                ) : (
                    <motion.button
                        key="fab"
                        onClick={handleCall}
                        disabled={state === 'calling'}
                        whileTap={{ scale: 0.92 }}
                        whileHover={{ scale: 1.05 }}
                        className="relative flex flex-col items-center justify-center w-14 h-14 bg-white border-2 border-slate-100 rounded-2xl shadow-xl hover:shadow-2xl hover:border-primary/30 transition-colors"
                    >
                        {state === 'calling' ? (
                            <motion.span
                                animate={{ rotate: [0, 15, -15, 0] }}
                                transition={{ repeat: 2, duration: 0.3 }}
                                className="text-2xl"
                            >
                                🔔
                            </motion.span>
                        ) : (
                            <span className="text-2xl">🔔</span>
                        )}
                        <span className="text-[9px] font-black text-slate-500 uppercase tracking-wide leading-none mt-0.5">
                            Waiter
                        </span>

                        {/* Ripple on idle */}
                        {state === 'idle' && (
                            <motion.div
                                className="absolute inset-0 rounded-2xl border-2 border-primary"
                                initial={{ scale: 1, opacity: 0.4 }}
                                animate={{ scale: 1.5, opacity: 0 }}
                                transition={{ duration: 1.5, repeat: Infinity, repeatDelay: 1 }}
                            />
                        )}
                    </motion.button>
                )}
            </AnimatePresence>

            {/* Table label below FAB */}
            {tableNumber && state === 'idle' && (
                <p className="text-center text-[9px] font-bold text-slate-400 mt-1.5 uppercase tracking-wide">
                    Table {tableNumber}
                </p>
            )}
        </div>
    );
}
